import styled from "styled-components";

const ListTotalCount = styled.section`
  display: flex;
  justify-content: flex-end;
`;

export default ListTotalCount;
